export const FETCH_EMPLOYEES = 'FETCH_EMPLOYEES';
export const FETCH_EMPLOYEE_COUNT = 'FETCH_EMPLOYEE_COUNT';
export const SET_SEARCH_EMPLOYEE = 'SET_SEARCH_EMPLOYEE';
